import { createSelector } from 'reselect'
import { API_URL_CARLINES } from '../../../constants/apiUrls'
import pendingRequestsSelector from './pendingRequestsSelector'
import exactRequestIsPending from './helpers/exactRequestIsPending'

const carlinesRequestIsPendingSelector = createSelector(
    pendingRequestsSelector,
    (pendingRequests): boolean => exactRequestIsPending(pendingRequests, API_URL_CARLINES),
)

export default carlinesRequestIsPendingSelector
